/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, September 13th 2022, 10:33:35 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Button from "@mui/material/Button";
import permissionDeniedIcon from "theme/assets/images/icons/icons8-denied-96.png";
import { APIStatusNotification } from "ui-widgets/alerts/APIStatusNotification";

export const PermissionDeniedNotification = ({ username, email }) => {
  const [open, setOpen] = React.useState(true);

  return (
    <APIStatusNotification
      open={open}
      title="Permission Denied!"
      icon={<img src={permissionDeniedIcon} alt="" />}
      message={
        <>
          Access denied: The account with username {username} and email {email} has been denied permission.
        </>
      }
      actions={<Button onClick={() => setOpen(false)}>Okay</Button>}
    />
  );
};
